module.exports = __webpack_public_path__ + "img/facebook.029c2d8c.svg";